import React from "react";
import { connect } from "react-redux";
import { firebaseDb } from "../../../core/firebase";
import Main from "../../components/main";
import Box from "../../components/box";
import H2 from "../../components/h2";
import "./styles.css";

class Affiliate extends React.Component {
  state = {
    tooltip: null,
    specialCommission: null,
    salesThisMonth: null,
    averageMonthlySales: null,
    currentCommission: null,
  };

  componentDidMount() {
    this.done1 = false;
    this.done2 = false;
  }

  monthlyAverageLogic = () => {
    const date = new Date();
    const date2 = new Date();
    const currentUTCDay = date.getUTCDate();
    const UTCMonthAndYear =
      date.getUTCMonth().toString() + date.getUTCFullYear();
    date2.setMonth(date2.getMonth() - 1);
    const oldUTCMonthAndYear =
      date2.getUTCMonth().toString() + date2.getUTCFullYear();
    if (this.props.affiliate.monthlySales) {
      let slicedMonth = parseInt(oldUTCMonthAndYear.slice(0, -4));
      let slicedYear = parseInt(oldUTCMonthAndYear.slice(-4));
      let joinedMonthYear = slicedMonth.toString() + slicedYear;
      let extraMonths = 0;
      // let ifCurrentMonthZeroRed = 0;

      while (
        !this.props.affiliate.monthlySales[joinedMonthYear] &&
        this.props.affiliate.monthlySales[joinedMonthYear] !== 0
      ) {
        if (
          Object.keys(this.props.affiliate.monthlySales).length === 1 &&
          this.props.affiliate.monthlySales[UTCMonthAndYear]
        ) {
          break;
        }
        extraMonths++;
        if (slicedMonth > 0) {
          slicedMonth--;
        } else {
          slicedMonth = 11;
          slicedYear--;
        }
        joinedMonthYear = slicedMonth.toString() + slicedYear;
      }

      let totalSales = 0;
      // eslint-disable-next-line guard-for-in
      for (let i in this.props.affiliate.monthlySales) {
        totalSales += this.props.affiliate.monthlySales[i];
      }
      let averageMonthlySales;
      let salesThisMonth;
      let currentCommission;
      const noOfMonths = Object.keys(this.props.affiliate.monthlySales).length;
      if (
        this.props.affiliate.monthlySales[UTCMonthAndYear] ||
        this.props.affiliate.monthlySales[UTCMonthAndYear] === 0
      ) {
        if (noOfMonths === 1) {
          averageMonthlySales = totalSales / (noOfMonths + extraMonths);
        } else {
          averageMonthlySales =
            totalSales / (noOfMonths + extraMonths - 1 + currentUTCDay * 0.033);
        }

        salesThisMonth = this.props.affiliate.monthlySales[UTCMonthAndYear];
      } else {
        averageMonthlySales =
          totalSales / (noOfMonths + extraMonths + currentUTCDay * 0.033);

        salesThisMonth = 0;
      }
      averageMonthlySales = Math.round(averageMonthlySales);
      if (averageMonthlySales >= 5) {
        currentCommission = "30%";
      }
      if (averageMonthlySales >= 10) {
        currentCommission = "40%";
      }
      if (averageMonthlySales >= 15) {
        currentCommission = "50%";
      }
      this.setState({
        salesThisMonth,
        averageMonthlySales,
        currentCommission,
      });
    } else {
      this.setState({
        salesThisMonth: 0,
        averageMonthlySales: 0,
        currentCommission: "20%",
      });
    }
  };

  componentDidUpdate() {
    if (this.props.uid && !this.done1) {
      firebaseDb
        .ref(`/user/${this.props.uid}/specialCommission`)
        .on("value", (snapshot) => {
          if (snapshot.val()) {
            this.setState({ specialCommission: `${snapshot.val()}%` });
          }
        });
      this.done1 = true;
    }
    if (this.props.affiliate && !this.done2) {
      this.monthlyAverageLogic();
      this.done2 = true;
    }
  }

  getCommission = () => {
    if (this.state.specialCommission) {
      return this.state.specialCommission;
    } else if (this.state.currentCommission) {
      return this.state.currentCommission;
    } else {
      return "20%";
    }
  };

  handleLinkClick = () => {
    const link = `https://ghast.io/a/${this.props.affiliate.aid}`;
    navigator.clipboard.writeText(link).then(
      () => {
        this.setState({ tooltip: "Link Copied" });
      },
      (err) => {
        console.error("Async: Could not copy text: ", err);
      }
    );
  };

  render() {
    const { name, photo, affiliate } = this.props;
    if (affiliate) {
      return (
        <div className="affiliate">
          <Box>
            <Main>
              <div className="aff-flex">
                <div className="affinfo">
                  <div>
                    <img src={photo} alt="affiliate avatar" />
                    <H2>{name}</H2>
                  </div>
                  <H2>Balance: ${affiliate.balance}</H2>
                  <H2>Total Earned: ${affiliate.totalearned}</H2>
                  <H2>Clicks: {affiliate.clicks}</H2>
                  <H2>Total Sales: {affiliate.conversions}</H2>
                  <H2>Sales This Month: {this.state.salesThisMonth}</H2>
                  <H2>
                    Average Monthly Sales: {this.state.averageMonthlySales}
                  </H2>
                  <H2>Current Commission Rate: {this.getCommission()}</H2>
                </div>
                <div className="afflink">
                  <H2>Your Affiliate Link</H2>
                  <div>
                    {this.state.tooltip ? (
                      <div className="tooltip">{this.state.tooltip}</div>
                    ) : null}
                    <p
                      className="afflinkbox"
                      onClick={this.handleLinkClick}
                      onMouseEnter={() =>
                        this.setState({ tooltip: "Copy Link" })
                      }
                      onMouseLeave={() => this.setState({ tooltip: null })}
                    >
                      https://ghast.io/a/{affiliate.aid}
                    </p>
                  </div>
                  <p>
                    Whenever someone uses your link to visit this website and
                    buys Ghast within 1 week, you get {this.getCommission()}{" "}
                    commission!
                  </p>
                </div>
              </div>
            </Main>
          </Box>
        </div>
      );
    } else {
      return (
        <Main>
          <Box>
            <H2>You are not an affiliate partner.</H2>
          </Box>
        </Main>
      );
    }
  }
}

const mapStateToProps = ({ user }) => ({
  uid: user.uid,
  name: user.displayName,
  photo: user.photoURL,
  affiliate: user.affiliate,
});

export default connect(mapStateToProps)(Affiliate);



/** WEBPACK FOOTER **
 ** ./src/views/pages/affiliate/index.js
 **/